import { Network, Alchemy } from 'alchemy-sdk';

export default class AdminAlchemyApi {
  private alchemy: Alchemy;
  constructor() {
    const settings = {
      apiKey: process.env.REACT_APP_ALCHEMY_API_KEY, // Replace with your Alchemy API Key.
      network: process.env.NODE_ENV === 'production' ? Network.MATIC_MAINNET : Network.MATIC_AMOY, // Replace with your network.
      url:
        process.env.NODE_ENV === 'production'
          ? `https://polygon-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY!}`
          : `https://polygon-amoy.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY!}`,
    };
    this.alchemy = new Alchemy(settings);
  }
  getProvider() {
    return this.alchemy.config.url;
  }

  getAlchemy() {
    return this.alchemy;
  }
}
